




































































































































import {
  defineComponent,
  ref,
  watch,
  PropType,
  computed,
} from '@vue/composition-api';
import { CollectionText } from '@oare/types';
import sl from '@/serviceLocator';

export interface OriginalTextInfo {
  excavationPrefix: string | null;
  excavationNumber: string | null;
  museumPrefix: string | null;
  museumNumber: string | null;
  publicationPrefix: string | null;
  publicationNumber: string | null;
}

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    texts: {
      type: Array as PropType<CollectionText[]>,
      required: true,
    },
    collectionUuid: {
      type: String,
      required: true,
    },
  },

  setup(props, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const store = sl.get('store');
    const router = sl.get('router');

    const hasEditPermission = computed(() =>
      store.hasPermission('EDIT_TEXT_INFO')
    );

    const canAddNewTexts = computed(() => store.hasPermission('ADD_NEW_TEXTS'));

    const originalTextInfoObject = ref<OriginalTextInfo>({
      excavationPrefix: null,
      excavationNumber: null,
      museumPrefix: null,
      museumNumber: null,
      publicationPrefix: null,
      publicationNumber: null,
    });

    const headers = ref([
      {
        text: 'Text Name',
        value: 'name',
      },
      {
        text: 'Excavation Info',
        value: 'excavation',
      },
      {
        text: 'Museum Info',
        value: 'museum',
      },
      {
        text: 'Primary Publication Info',
        value: 'publication',
      },
    ]);

    const editText = ref<string>();

    const toggleTextInfo = (uuid: string, item: OriginalTextInfo) => {
      originalTextInfoObject.value.excavationPrefix = item.excavationPrefix;
      originalTextInfoObject.value.excavationNumber = item.excavationNumber;
      originalTextInfoObject.value.museumPrefix = item.museumPrefix;
      originalTextInfoObject.value.museumNumber = item.museumNumber;
      originalTextInfoObject.value.publicationPrefix = item.publicationPrefix;
      originalTextInfoObject.value.publicationNumber = item.publicationNumber;

      editText.value = uuid;
    };

    const cancelEditTextInfo = (item: OriginalTextInfo) => {
      item.excavationPrefix = originalTextInfoObject.value.excavationPrefix;
      item.excavationNumber = originalTextInfoObject.value.excavationNumber;
      item.museumPrefix = originalTextInfoObject.value.museumPrefix;
      item.museumNumber = originalTextInfoObject.value.museumNumber;
      item.publicationPrefix = originalTextInfoObject.value.publicationPrefix;
      item.publicationNumber = originalTextInfoObject.value.publicationNumber;

      editText.value = undefined;
    };

    const updateTextInfo = async (item: any) => {
      try {
        await server.updateTextInfo(
          item.uuid,
          item.excavationPrefix,
          item.excavationNumber,
          item.museumPrefix,
          item.museumNumber,
          item.publicationPrefix,
          item.publicationNumber
        );
        editText.value = undefined;
      } catch (err) {
        actions.showErrorSnackbar(
          'Error editing text info. Please try again.',
          err as Error
        );
      }
    };

    const createEpigraphy = (textUuid: string) => {
      router.push(`/add_text_epigraphy/${props.collectionUuid}/${textUuid}`);
    };

    return {
      headers,
      editText,
      toggleTextInfo,
      cancelEditTextInfo,
      updateTextInfo,
      hasEditPermission,
      createEpigraphy,
      canAddNewTexts,
    };
  },
});
